import React from 'react';
import * as _ from 'lodash';
import { Form, Icon, Table } from 'semantic-ui-react';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../HelperMethods/FormUtils';

const availabilityInitValue = {
  availabilityStartTime: '',
  availabilityStartDate: '',
  availabilityEndTime: '',
  availabilityEndDate: '',
};
let valueObj = {
  availabilityStartTime: '',
  availabilityStartDate: '',
  availabilityEndTime: '',
  availabilityEndDate: '',
};
const AvailibiltyCompoent = ({ formik }) => {
  const formvalues = formik?.values;
  const availabilityClonedValues = _.cloneDeep(formvalues.availability_availability);
  const errorValues = _.get(formik, 'errors.availability_availability', []);
  const onValueChangetest = (event, index) => {
    const initialValue = availabilityClonedValues[index];
    if (!_.isEmpty(event.target.value)) {
      for (const keys in availabilityInitValue) {
        if (keys === event.target.name) valueObj[event.target.name] = event.target.value;
        else valueObj[keys] = initialValue[keys];
      }
      availabilityClonedValues[index] = valueObj;

      if (
        index + 1 === availabilityClonedValues.length &&
        valueObj.availabilityStartTime &&
        valueObj.availabilityStartDate &&
        valueObj.availabilityEndTime &&
        valueObj.availabilityEndDate
      ) {
        valueObj = {
          availabilityStartTime: '',
          availabilityStartDate: '',
          availabilityEndTime: '',
          availabilityEndDate: '',
        };
        availabilityClonedValues.push(availabilityInitValue);
      }
      formik.setFieldValue('availability_availability', availabilityClonedValues, false);
    }
  };

  const handleDeleteRow = (index) => {
    const partsClone = _.cloneDeep(formik.values.availability_availability);
    const errorClone = _.cloneDeep(formik.errors.availability_availability);
    try {
      if (errorClone) {
        errorClone.splice(index, 1);
        formik.setFieldError('availability_availability', errorClone);
      }

      partsClone.splice(index, 1);
      formik.setFieldValue('availability_availability', partsClone, false);
    } catch (e) {
      console.error(e);
    }

    if (_.isEmpty(partsClone)) {
      formik.setFieldValue('availability_availability', [availabilityInitValue], false);
    }
  };
  return (
    <div>
      <Table id="partsTable">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2}>Start Date </Table.HeaderCell>
            <Table.HeaderCell width={2}>End Date </Table.HeaderCell>
            <Table.HeaderCell width={2}>Start Time </Table.HeaderCell>
            <Table.HeaderCell width={2}>End Time </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        {_.get(formik, 'values.availability_availability', []).map(
          ({ availabilityStartTime, availabilityStartDate, availabilityEndTime, availabilityEndDate }, index) => {
            return (
              <>
                <Table.Body key={index}>
                  <Table.Row>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DATE]({
                          name: 'availabilityStartDate',
                          placeholder: 'Start Date ',
                          value: availabilityStartDate,

                          onChange: (event) => {
                            onValueChangetest(event, index);
                          },
                          index: `${index}`,
                        })}

                        {/* <DateTimeComponent
                        name="startDate"
                        placeholder="Start Date "
                        value={{ date: availabilityStartDate, time: availabilityStartTime }}
                        disabled={false}
                        onChange={(event) => {
                          onValueChange(event, index);
                        }}
                        index={index}
                      /> */}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DATE]({
                          name: 'availabilityEndDate',
                          placeholder: 'End Date',
                          value: availabilityEndDate,

                          onChange: (event) => {
                            onValueChangetest(event, index);
                          },
                          index: `${index}`,
                        })}
                        {/* <DateTimeComponent
                        name="availabilityEndDate"
                        placeholder="End Date"
                        value={{ date: availabilityStartDate, time: availabilityStartTime }}
                        disabled={false}
                        onChange={(event) => {
                          onValueChange(event, index);
                        }}
                        index={index}
                      /> */}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.TIME]({
                          name: 'availabilityStartTime',
                          placeholder: 'Start Time',
                          value: availabilityStartTime,

                          onChange: (event) => {
                            onValueChangetest(event, index);
                          },
                          index: `${index}`,
                        })}
                        {/* <DateTimeComponent
                        name="availabilityStartTime"
                        placeholder="Start Time"
                        value={{ date: availabilityStartDate, time: availabilityStartTime }}
                        disabled={false}
                        onChange={(event) => {
                          onValueChange(event, index);
                        }}
                        index={index}
                      /> */}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.TIME]({
                          name: 'availabilityEndTime',
                          placeholder: 'End  Time',
                          value: availabilityEndTime,

                          onChange: (event) => {
                            onValueChangetest(event, index);
                          },
                          index: `${index}`,
                        })}
                        {/* <DateTimeComponent
                        name="availabilityEndTime"
                        placeholder="End  Time"
                        value={{ date: availabilityEndDate, time: availabilityEndTime }}
                        disabled={false}
                        onChange={(event) => {
                          onValueChange(event, index);
                        }}
                        index={index}
                      /> */}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Icon name="trash alternate outline" onClick={() => handleDeleteRow(index)} />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
                {errorValues[index] && errorValues[index].error && (
                  <div className="errorText" style={{ position: 'absolute', lineHeight: '0px' }}>
                    *{errorValues[index].error}
                  </div>
                )}
              </>
            );
          }
        )}
      </Table>
    </div>
  );
};

export default AvailibiltyCompoent;
